import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col bg-gray-lp-1000" }
const _hoisted_2 = {
  key: 0,
  class: "border-b border-gray-lp-2100 pt-3 bg-white"
}
const _hoisted_3 = {
  class: "flex-grow px-3 py-2 flex flex-col",
  style: {"height":"calc(calc(100vh / var(--viewport-scale)) - 170px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isSidebarAndBreadcrumbV2)
      ? (_openBlock(), _createBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_Tabs, {
      modelValue: _ctx.activeMenu,
      "onUpdate:modelValue": _ctx.onChangeTabs,
      data: _ctx.tabs,
      rounded: false,
      marginTop: 0,
      marginBottom: 0,
      titleSize: 16,
      gap: 8,
      class: "px-4 flex",
      customClass: "px-4"
    }, null, 8, ["modelValue", "onUpdate:modelValue", "data"]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeMenu)))
    ])
  ]))
}